import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DataRoomView = "folder" | "tree";

export type DataRoomState = {
  [dataRoomId: string]: {
    view: DataRoomView;
  };
};

const initialState: DataRoomState = {};

export const { actions, reducer } = createSlice({
  name: "data_room",
  initialState,
  reducers: {
    setView: (
      state,
      action: PayloadAction<{ dataRoomId: string; view: DataRoomView }>,
    ) => {
      if (!state[action.payload.dataRoomId]) {
        state[action.payload.dataRoomId] = {
          view: action.payload.view,
        };
      } else {
        state[action.payload.dataRoomId].view = action.payload.view;
      }
    },
  },
});
